// Single source of truth for role names used in frontend.
// Backend returns roles like: ["ADMIN", "CUSTOMER_USER"] (no prefix)
// Frontend standard: no prefix (same as backend)

export const ROLE_ENUM = Object.freeze({
  ADMIN: 'ADMIN',
  ACCOUNT_ADMIN: 'ACCOUNT_ADMIN',
  CUSTOMER_MANAGER: 'CUSTOMER_MANAGER',
  CUSTOMER_USER: 'CUSTOMER_USER',
  OPERATION_MANAGER: 'OPERATION_MANAGER',
  SYSTEM: 'SYSTEM',
  SUPERADMIN: 'SUPERADMIN'
});

// Frontend role strings (no prefix)
export const ROLES = Object.freeze({
  ADMIN: ROLE_ENUM.ADMIN,
  ACCOUNT_ADMIN: ROLE_ENUM.ACCOUNT_ADMIN,
  CUSTOMER_MANAGER: ROLE_ENUM.CUSTOMER_MANAGER,
  CUSTOMER_USER: ROLE_ENUM.CUSTOMER_USER,
  OPERATION_MANAGER: ROLE_ENUM.OPERATION_MANAGER,
  SYSTEM: ROLE_ENUM.SYSTEM,
  SUPERADMIN: ROLE_ENUM.SUPERADMIN
});

export const ADMIN_OVERRIDE_ROLE_ENUMS = Object.freeze([ROLE_ENUM.SUPERADMIN]);

export const CUSTOMER_ROLES = Object.freeze([ROLES.CUSTOMER_MANAGER, ROLES.CUSTOMER_USER]);

export const CUSTOMER_ROLES_WITH_SYSTEM = Object.freeze([...CUSTOMER_ROLES, ROLES.SYSTEM]);

export function normalizeRole(role) {
  return String(role || '').trim();
}
